// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__ZBTjP","title":"styles_title__dA7iY"};